/** @jsxImportSource @emotion/react */
import { TextField } from "@mui/material"
import { withMyTheme } from "../../../../theme/theme"
import { css } from "@mui/material"

const TextFieldStyle = withMyTheme((theme) => css`
    width: 100%;
    
    & .MuiInputLabel-root {
        font-family: ${theme.typography.body1.fontFamily};
        color: ${theme.palette.text.primary};
        font-size: 1rem;
        background: white;
        padding: 0 6px;
        
        &.Mui-focused {
            color: ${theme.palette.primary.main};
        }
    }
    
    & .MuiOutlinedInput-root {
        border-radius: 12px;
        background-color: white;
        
        &:hover .MuiOutlinedInput-notchedOutline {
            border-color: ${theme.palette.primary.main};
        }
        
        &.Mui-focused .MuiOutlinedInput-notchedOutline {
            border-color: ${theme.palette.primary.main};
            border-width: 2px;
        }
    }
    
    & .MuiInputBase-input {
        font-family: ${theme.typography.body1.fontFamily};
        font-size: 1rem;
        padding: 14px 16px;
    }
`)

interface LocationDetailsFieldProps {
    label: string
    placeholder: string
    value: string
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const LocationDetailsField = ({ label, placeholder, value, onChange }: LocationDetailsFieldProps) => {
    return (
        <TextField
            label={label}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            multiline
            rows={4}
            fullWidth
            variant="outlined"
            InputLabelProps={{
                shrink: true,
            }}
            css={TextFieldStyle}
        />
    )
}
